import { unitPricingToTotalGross } from '../../../functions/unit-pricing-to-total-gross.function';
import { unitPricingToTotalNet } from '../../../functions/unit-pricing-to-total-net.function';
import { unitPricingToTotalTax } from '../../../functions/unit-pricing-to-total-tax.function';
import type { QuotationPricingItemDto } from '../dtos/quotation-pricing-item.dto';
import type { NetTaxGrossTotals } from '../types/net-tax-gross-totals.type';

/**
 * Folds a list of pricing items into a single net/tax/gross bucket.
 */
export function aggregatePricingItemTotals(
  items: QuotationPricingItemDto[] = [],
): NetTaxGrossTotals {
  return items.reduce(
    (acc, item) => {
      const pricingItem = {
        units: item.units ?? 1,
        unitPrice: item.unitPrice,
        unitTaxRate: item.unitTaxRate,
        isTaxIncluded: item.isTaxIncluded ?? false,
      };
      acc.net += unitPricingToTotalNet(pricingItem);
      acc.tax += unitPricingToTotalTax(pricingItem);
      acc.gross += unitPricingToTotalGross(pricingItem);
      return acc;
    },
    { net: 0, tax: 0, gross: 0 },
  );
}
